// Action Types
const FETCH_SUMMARY_START = 'zen/dashboardSummary/FETCH_SUMMARY_START';
const FETCH_SUMMARY_SUCCESS = 'zen/dashboardSummary/FETCH_SUMMARY_SUCCESS';
const FETCH_SUMMARY_FAILURE = 'zen/dashboardSummary/FETCH_SUMMARY_FAILURE';
const TOGGLE_SUMMARY_PANEL = 'zen/dashboardSummary/TOGGLE_SUMMARY_PANEL';
const SET_FEATURE_ENABLED = 'zen/dashboardSummary/SET_FEATURE_ENABLED';
const SHOW_INTENTION_FLOW = 'zen/dashboardSummary/SHOW_INTENTION_FLOW';
const HIDE_INTENTION_FLOW = 'zen/dashboardSummary/HIDE_INTENTION_FLOW';
const SET_DASHBOARD_INTENTION = 'zen/dashboardSummary/SET_DASHBOARD_INTENTION';
const SET_DASHBOARD_INTENTION_PRESET = 'zen/dashboardSummary/SET_DASHBOARD_INTENTION_PRESET';

// Initial State
const initialState = {
  isLoading: false,
  jsonContent: null,
  isExpanded: false,
  hasContent: false,
  featureEnabled: false,
  error: null,
  showIntentionFlow: false,
  dashboardIntention: null,
  dashboardIntentionPreset: null, // Store the preset ID
  isEditingIntention: false,
  cacheInfo: null,
  generatedAt: null
};

// Reducer
export default function reducer(state = initialState, action) {
  switch (action.type) {
    case FETCH_SUMMARY_START:
      return {
        ...state,
        isLoading: true,
        error: null
      };

    case FETCH_SUMMARY_SUCCESS:
      return {
        ...state,
        isLoading: false,
        jsonContent: action.payload,
        hasContent: true,
        isExpanded: true, // Auto-expand when content is ready
        error: null,
        cacheInfo: action.payload?.cacheInfo || null,
        generatedAt: action.payload?.generatedAt || null
      };

    case FETCH_SUMMARY_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: action.payload,
        hasContent: false
      };

    case TOGGLE_SUMMARY_PANEL:
      return {
        ...state,
        isExpanded: !state.isExpanded
      };

    case SET_FEATURE_ENABLED:
      return {
        ...state,
        featureEnabled: action.payload
      };

    case SHOW_INTENTION_FLOW:
      return {
        ...state,
        showIntentionFlow: true,
        isEditingIntention: action.payload || false,
        isExpanded: true // Auto-expand panel for intention flow
      };

    case HIDE_INTENTION_FLOW:
      return {
        ...state,
        showIntentionFlow: false,
        isEditingIntention: false
      };

    case SET_DASHBOARD_INTENTION:
      return {
        ...state,
        dashboardIntention: action.payload,
        showIntentionFlow: false,
        isEditingIntention: false
      };

    case SET_DASHBOARD_INTENTION_PRESET:
      return {
        ...state,
        dashboardIntentionPreset: action.payload
      };

    default:
      return state;
  }
}

// Action Creators
export const fetchSummaryStart = (payload) => ({
  type: FETCH_SUMMARY_START,
  payload: typeof payload === 'string' ? { dashboardId: payload } : payload
});

export const fetchSummarySuccess = (jsonContent) => ({
  type: FETCH_SUMMARY_SUCCESS,
  payload: jsonContent
});

export const fetchSummaryFailure = (error) => ({
  type: FETCH_SUMMARY_FAILURE,
  payload: error
});

export const toggleSummaryPanel = () => ({
  type: TOGGLE_SUMMARY_PANEL
});

export const setFeatureEnabled = (enabled) => ({
  type: SET_FEATURE_ENABLED,
  payload: enabled
});

export const showIntentionFlow = (isEditing = false) => ({
  type: SHOW_INTENTION_FLOW,
  payload: isEditing
});

export const hideIntentionFlow = () => ({
  type: HIDE_INTENTION_FLOW
});

export const setDashboardIntention = (intention) => ({
  type: SET_DASHBOARD_INTENTION,
  payload: intention
});

export const setDashboardIntentionPreset = (presetId) => ({
  type: SET_DASHBOARD_INTENTION_PRESET,
  payload: presetId
});

// Selectors
export const getIsLoading = (state) => state.DashboardSummary.isLoading;
export const getJsonContent = (state) => state.DashboardSummary.jsonContent;
export const getIsExpanded = (state) => state.DashboardSummary.isExpanded;
export const getHasContent = (state) => state.DashboardSummary.hasContent;
export const getFeatureEnabled = () => {
  const account = window.Account?.getAccountForActiveCampaign();
  const accountHasFeatureFlag = account?.hasFeatureFlag?.('smart_dashboards') === true;
  const splitEnabled = window.splitHelper?.getTreatment?.('Smart_Dashboard') === 'on';
  return accountHasFeatureFlag && splitEnabled;
};
export const getError = (state) => state.DashboardSummary.error;
export const getShowIntentionFlow = (state) => state.DashboardSummary.showIntentionFlow;
export const getDashboardIntention = (state) => state.DashboardSummary.dashboardIntention;
export const getDashboardIntentionPreset = (state) => state.DashboardSummary.dashboardIntentionPreset;
export const getIsEditingIntention = (state) => state.DashboardSummary.isEditingIntention;
export const getCacheInfo = (state) => state.DashboardSummary.cacheInfo;
export const getGeneratedAt = (state) => state.DashboardSummary.generatedAt;

// Export action types for saga
export {
  FETCH_SUMMARY_START,
  FETCH_SUMMARY_SUCCESS,
  FETCH_SUMMARY_FAILURE,
  SHOW_INTENTION_FLOW,
  HIDE_INTENTION_FLOW,
  SET_DASHBOARD_INTENTION
};
